import {Component, Inject} from '@angular/core';
import {MD_DIALOG_DATA, MdDialog, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {

  constructor( @Inject(MD_DIALOG_DATA) public messageSent: boolean,
               public dialogRef: MdDialogRef<ConfirmationDialogComponent>,
               public dialog: MdDialog) { }

  onOk() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/confirmation-dialog/confirmation-dialog.component.ts